import React from "react";
import './galeri.css';
import Portfolio1 from './../../assets/2.jpg';
import Portfolio2 from './../../assets/3.jpg';
import Portfolio3 from './../../assets/4.jpg';
import Portfolio4 from './../../assets/5.jpg';

const Galeri = () => {
    return (
        <section id='galeri'>
            <h2 className="galerititle">My Gallery</h2>
            <span className="galeriDesc">Here is a photo gallery of some of my completed projects.</span>
            <div className="galeriImgs">
                <img src={Portfolio1} alt="" className="galeriImg"/>
                <img src={Portfolio2} alt="" className="galeriImg"/>
                <img src={Portfolio3} alt="" className="galeriImg"/>
                <img src={Portfolio4} alt="" className="galeriImg"/>
            </div>
            <button className="galeriBtn">See More</button>
        </section>
    );
}

export default Galeri